import {
  getUser, connexion,
} from '@/api/login/index';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import { QUADRA_ADMIN } from '@/configuration/general/paramConf';
import * as allTypes from '../mutation-type';
import * as types from './user-mutation-type';
import {
  resetState,
} from '../store';

function initialState() {
  return {
    security: { isLogged: false },
    site: '',
    token: null,
    user: null,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.LOG_IN](state, user) {
    state.security = { isLogged: true, ...user };
  },
  [types.SET_USER](state, user) {
    state.user = user;
  },
  [types.LOG_OUT](state) {
    state.security = { isLogged: false };
    state.user = {};
    resetState();
  },
  [types.SET_SITE](state, site) {
    state.site = site;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async logIn({ commit, getters }, payload) {
    try {
      const responseConnexion = await connexion(payload);
      if (payload.site !== getters.site || payload.email !== getters.userEmail) {
        resetState();
        commit(types.SET_SITE, payload.site);
      }
      commit(types.LOG_IN, responseConnexion.data.result);

      let email = payload.secondaryUserNameOrEmailAddress || payload.email;
      if (email === 'admin') {
        email = 'support@quadra-diffusion.fr';
      }
      const reponseUser = (await getUser(email)).data.result;
      reponseUser.decorator = {
        nomPrenom: nomPrenomGetter(reponseUser),
      };
      commit(types.SET_USER, reponseUser);
    } catch (err) {
      if (!payload.noLogout) {
        commit(types.LOG_OUT);
      }
      throw (err);
    }
  },
  logOut: ({ commit }) => {
    return new Promise((resolve) => {
      commit(types.LOG_OUT);
      resolve();
    });
  },
};

const getters = {
  accessToken: state => {
    if (state.security.access_token && state.security.access_token !== undefined) {
      return state.security.access_token;
    }
    return state.security.accessToken;
  },
  refreshToken: state => {
    return state.security.refresh_token;
  },
  isLogged: state => {
    return state.security.isLogged;
  },
  userEmail: state => {
    return state.user ? state.user.email : '';
  },
  isSupport: state => {
    return state.user ? (state.user.email === 'support@quadra-diffusion.fr' || state.user.identifiant === QUADRA_ADMIN) : false;
  },
  site: state => {
    return state.site;
  },
  user: state => {
    return state.user;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
